import { trackInteraction } from "../analytics/analyticsUtil";
import { DIRECTION, ANALYTICS_EVENT, ACTION_TYPE } from "../analytics/types";
import { ROUTES } from "../shared/constants/routes";
import { useActiveArticle } from "../features/news-feed/hooks/useActiveArticle";
import { useNavigation } from "@react-navigation/native";
import { useCollectionStore } from "../store/collectionStore";
import { useNavStore } from "../store/navStore";

export const useAudioFunctions = () => {
    const navigation = useNavigation();
    const { selectedCollection } = useCollectionStore();
    const {  nextArticle, previousArticle } = useActiveArticle();
    const { getCurrentRoute } = useNavStore();
    const basePayload = {
        event: ANALYTICS_EVENT.INTERACTION as const,
        screen_name: ROUTES.LISTEN,
    };

    const togglePrevious = () => {
        (navigation as any).navigate(getCurrentRoute()?.name, { articleId: previousArticle?.id, collectionId: selectedCollection?.id });
    }
    const toggleNext = () => {
        (navigation as any).navigate(getCurrentRoute()?.name, { articleId: nextArticle?.id, collectionId: selectedCollection?.id });
    }

    const swipeDown = () => {
        trackInteraction({
            ...basePayload,
            action: ACTION_TYPE.SWIPE,
            direction: DIRECTION.DOWN,
            component: "AudioPlayer"
        });

        togglePrevious();
    }
    const swipeUp = () => {
        trackInteraction({
            ...basePayload,
            action: ACTION_TYPE.SWIPE,
            direction: DIRECTION.UP,
            component: "AudioPlayer"
        });

        toggleNext();
    }

    return { toggleNext, togglePrevious, swipeUp, swipeDown };
}